import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";


import { alunos_geo_mediana, alunos_geo_raio_de_90_porcento } from "../../services/api";

const Alunos_distancias = (props) => {

    const [dataMED, setDataMED] = useState([]);
    const [data90p, setData90p] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const responseMED = await alunos_geo_mediana(data_inicio, data_fim);
            setDataMED(responseMED);

            const response90p = await alunos_geo_raio_de_90_porcento(data_inicio, data_fim);
            setData90p(response90p);
        } catch (error) {
            console.error(error);
        }
    };

    // console.log("dataMED", dataMED);
    // console.log("data90p", data90p);

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // {
    // 	"nome": "BARRA DA TIJUCA",
    // 	"mediana_km": "5,05"
    // },


    let chartData90p = [];
    if (typeof data90p !== 'undefined') {


        chartData90p = data90p.map((item, index) => {
            const row = [item.nome];
            row.push(item.raio_de_90_porcento + " km");

            return row;
        });
    };

    chartData90p.sort()
    chartData90p.unshift(['Unidade', 'Abrangência 🌐']);

    const options90 = {
        allowHtml: true,
        pageSize: 15,

    };

    let chartDataMediana = [];
    if (typeof dataMED !== 'undefined') {


        chartDataMediana = dataMED.map((item, index) => {
            const row = [item.nome];
            row.push(item.mediana_km + " km");

            return row;
        });
    };

    chartDataMediana.sort()
    chartDataMediana.unshift(['Unidade', 'Distancia Média 📍']);

    console.log('chartDataMediana', chartDataMediana)

    const options = {
        allowHtml: true,
        pageSize: 15,

    };

    return (
        <div className="distancias">
            <h2>
                <center>
                    Distâncias 📍 e Abrangência 🌐 das Unidades
                </center>
            </h2>
            <div className="info-box p-4 bg-light border rounded">
                <h5 className="mb-3">Entendendo a Cobertura</h5>

                <p className="mb-2">
                    <strong>📍 Distância (Mediana):</strong> Define o nosso <em>Núcleo Local</em>.
                    Indica o raio onde estão concentrados 50% dos alunos. Unidades com este número baixo têm forte apelo de vizinhança e acesso facilitado a pé.
                </p>

                <p className="mb-0">
                    <strong>🌐 Abrangência (Raio 90%):</strong> Define nossa <em>Área de Atuação Real</em>.
                    Representa a distância máxima percorrida pela vasta maioria dos alunos (excluindo os 10% mais distantes ou erros de cadastro). Essencial para planejar rotas de transporte e campanhas de marketing regional.
                </p>
            </div>
            <Row>
                <Col lg={6} sm={12}>
                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={chartDataMediana}
                        options={options}
                    />
                </Col>
                <Col lg={6} sm={12}>

                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={chartData90p}
                        options={options90}
                    />
                </Col>
            </Row>

        </div>
    );
};
export default Alunos_distancias;